import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { CHART_COLORS } from '../../../../core/constants/financial';

// Taxa de conversão e donut são por quantidade de orçamentos (não por R$), a pedido do cliente.
const OrcamentacaoPanel = ({
  realizados, aprovados, naoAprovados, taxaConversao, ticketMedio,
  qtdRealizados, qtdAprovados, qtdNaoAprovados,
  colors, brl, num, pct, loading,
}) => {
  const totalQtd = (Number(qtdAprovados) || 0) + (Number(qtdNaoAprovados) || 0);
  const data = [
    { name: 'Aprovados', value: Number(qtdAprovados) || 0, color: colors.green },
    { name: 'Não aprovados', value: Number(qtdNaoAprovados) || 0, color: colors.red },
  ];
  const isEmpty = loading || totalQtd === 0;

  return (
    <section className="dg-card dg-budget-card">
      <div className="dg-section-title">
        <span className="dg-dot" style={{ background: colors.blue }} />
        <span>Orçamentação</span>
      </div>

      <div className="dg-budget-content">
        <div className="dg-budget-stats">
          <div className="dg-budget-stat">
            <div className="dg-budget-stat-value">{loading ? '—' : brl(realizados)}</div>
            <div className="dg-budget-stat-label">Orçamentos realizados</div>
            <div className="dg-budget-stat-count">{loading ? '' : `${num(qtdRealizados)} no período`}</div>
            <div className="dg-budget-stat-ticket">
              <span>Ticket médio</span>
              <strong>{loading ? '—' : brl(ticketMedio)}</strong>
            </div>
          </div>
        </div>

        <div className="dg-approval-content">
          {isEmpty ? (
            <div className="dg-empty">{loading ? 'Carregando…' : 'Sem orçamentos no período'}</div>
          ) : (
            <>
              <div className="dg-donut">
                <ResponsiveContainer width={150} height={150}>
                  <PieChart>
                    <Pie data={data} dataKey="value" nameKey="name" innerRadius={50} outerRadius={74} paddingAngle={2} stroke="none">
                      {data.map((d) => (
                        <Cell key={d.name} fill={d.color} />
                      ))}
                    </Pie>
                    <Tooltip
                      wrapperStyle={{ zIndex: 100 }}
                      formatter={(value, name) => [`${num(value)} orçamentos`, name]}
                      contentStyle={{ background: CHART_COLORS.tooltipBg, border: '1px solid #383838', borderRadius: 6, fontSize: 12 }}
                      itemStyle={{ color: '#fff' }}
                    />
                  </PieChart>
                </ResponsiveContainer>
                <div className="dg-donut-center">
                  <div className="dg-donut-value">{pct(taxaConversao)}</div>
                  <div className="dg-donut-label">Conversão</div>
                </div>
              </div>

              <div className="dg-approval-legend">
                <div className="dg-legend-item">
                  <span style={{ color: colors.green }}>● Aprovados</span>
                  <span className="dg-legend-value" style={{ color: colors.green }}>{num(qtdAprovados)} orçamentos</span>
                  <small>{brl(aprovados)}</small>
                </div>
                <div className="dg-legend-item">
                  <span style={{ color: colors.red }}>● Não aprovados</span>
                  <span className="dg-legend-value" style={{ color: colors.red }}>{num(qtdNaoAprovados)} orçamentos</span>
                  <small>{brl(naoAprovados)}</small>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default OrcamentacaoPanel;
